<template>
    <div id="app">
        <router-view v-wechat-title="$route.meta.title"></router-view>
        <!--<div class="alert">alert alert alert</div>-->
    </div>
</template>

<script>
  //import App from "./components/common/js/App.js"
  //let app;
  export default {
    name: 'App',
    data: function () {
      return {
        api_token: null,
        wxConfig: {}
      }
    },
    created: function () {
      var vm = this;
    }
  }
</script>


<style>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: "微软雅黑", "microsoft yahei", "microsoft sans serif";
        font-size: 4vw;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -ms-tap-highlight-color: rgba(0, 0, 0, 0);
        -moz-tap-highlight-color: rgba(0, 0, 0, 0);
        -o-tap-highlight-color: rgba(0, 0, 0, 0);
        tap-highlight-color: rgba(0, 0, 0, 0);
    }

    body {
        background: #fff;
    }

    ul,
    ol,
    li {
        list-style: none;
    }

    img {
        max-width: 100%;
        border: none;
    }

    a {
        color: #333;
        text-decoration: none;
    }

    a:hover {
        color: #333;
    }

    #app {
        width: 100vw;
        height: auto;
        min-height: 100vh;
        overflow: hidden;
        background-color: #fff;
    }
    #app>div{
        min-height: 100vh;
    }
    .alert {
        width: auto;
        min-width: 6rem;
        max-width: 15rem;
        height: auto;
        padding: 0.2rem 1rem;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 0.3rem;
        background-color: rgba(0, 0, 0, 0.7);
        font-size: 1rem;
        line-height: 200%;
        text-align: center;
        color: #fff;
    }
    /*会员账户*/
    .userinfo {
        min-height: 100vh;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue